import createAction from 'loankeeper-common/helpers/createAction'

import { isOpen } from './selectors'

// interface OpenParams {
//   name: string;
//   message?: string;
//   onClose?: Function;
//   plain?: Boolean;
//   code?: string;
// }

export const OPEN_LK_MODAL = 'LKModal/OPEN'

export function open({ name, message, ...params }, code, onclose) {
  return createAction(OPEN_LK_MODAL, {
    name,
    message,
    params: Object.keys(params).length ? params : undefined,
    code: { code },
    onclose,
  })
}

export const CLOSE_LK_MODAL = 'LKModal/CLOSE'
export const close = (name) => (dispatch, getState) => {
  if (isOpen(getState(), name)) {
    dispatch(createAction(CLOSE_LK_MODAL, { name }))
  }
}
